<template lang="html">

    <article class="oferta-el row-between">
        <div class="left">
            <div class="top row-start">
                <h4 v-if="!!data.idOferta" class="codigo">[{{data.idOferta}}]</h4>
                <h2 class="titulo">{{data.puesto}}</h2>
                <h3 class="entidad" v-if="data.entidad">{{data.entidad}}</h3>
            </div>
            <div class="middle row-start">
                <h3 v-if="!!data.fechaFirma" class="fecha">{{data.fechaFirma}}</h3>
                <h3 v-if="!!data.provinciaOferta" class="localizacion">{{data.provinciaOferta}}</h3>
                <h3 v-if="!!data.sectorOferta" class="sector">{{data.sectorOferta}}</h3>
                <h3 v-if="!!data.nombreEmpresa" class="empresa">{{data.nombreEmpresa}}</h3>
            </div>
        </div>

        <div class="right">

            <a v-if="!!data.urlAnexo" :href="data.urlAnexo" target="_blank" class="btn skull">Documentación</a>
            
        </div>

    </article>

</template>

<script lang="js">
    export default {
        name: 'oferta',
        props:['data']

    }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/parts/practica-formalizada.vue